import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import {
  AiOfferLock_OfferLockDataFragment,
  AiOfferLock_ViewerFragment,
} from './__generated__/ai-offer-lock.graphql'
import { AiOfferLockContent } from './ai-offer-lock-content'
import { ModalLock } from './modal-lock'

export interface AiOfferLockProps {
  offerLockData: AiOfferLock_OfferLockDataFragment
  viewer?: AiOfferLock_ViewerFragment | null
}

export function AiOfferLock({ offerLockData, viewer }: AiOfferLockProps) {
  const { componentType } = useContext(BoxLockContext)
  const content = <AiOfferLockContent viewer={viewer} offerLockData={offerLockData} />

  switch (componentType) {
    case 'modal':
      return <ModalLock offerLockBody={offerLockData.body}>{content}</ModalLock>
    default:
      return null
  }
}

AiOfferLock.fragments = {
  offerLockData: gql`
    fragment AiOfferLock_offerLockData on OfferLockData {
      ...AiOfferLockContent_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${AiOfferLockContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment AiOfferLock_viewer on Profile {
      ...AiOfferLockContent_viewer
    }
    ${AiOfferLockContent.fragments.viewer}
  `,
}
